import SEO from "../components/Head/Social"

import Navigation from '../components/Landing/Navigation'; 
import Pricing from '../components/Landing/Pricing';
import Footer from '../components/Landing/Footer';

const title = "Try Diagram - The most complete Nocode API builder"
const description = "Native nocode backend in minutes with simple drag-and-drop nodes. Supports MongoDB, Firestore, EasyDB, JWT tokens, Stripe and others."

const IndexPage = () => (
  <>
    <SEO titleNoTemplate={title} description={description}/>
    <Navigation />
    <Pricing />
    <Footer />
  </>
)

export default IndexPage
